import { render, staticRenderFns } from "./EditMarketModal.vue?vue&type=template&id=d61c53c6&scoped=true&"
import script from "./EditMarketModal.vue?vue&type=script&lang=js&"
export * from "./EditMarketModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61c53c6",
  null
  
)

export default component.exports